/* global Swiper */
document.querySelectorAll( '.b-services-slider' ).forEach( ( block ) => {

	/////////////////////
	// BLOCK CODE HERE //
	/////////////////////
	const blockSwiper = block.querySelector( '.b-services-slider__swiper .swiper' );

	new Swiper( blockSwiper, {
		autoplay: {
			delay: 3000,
		},
		spaceBetween: 80,
		loop: true,
		slidesPerView: 3,
		slideClass: 'b-services-slider-single',
		breakpoints: {
			0: {
				slidesPerView: 1,
				spaceBetween: 15,
			},
			1200: {
				slidesPerView: 2,
				spaceBetween: 40,
			},
			1650: {
				slidesPerView: 3,
				spaceBetween: 40,
			},
			1920: {
				slidesPerView: 3,
				spaceBetween: 80,
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	} );

	const allSlides = block.querySelectorAll( '.b-services-slider-single' )

	allSlides.forEach( ( slide ) => {

		const readMore = slide.querySelector( '.js-read-more' )
		const imageLink = slide.querySelector( '.wp-block-image' )

		if ( readMore ) {

			imageLink.appendChild( readMore )

		}

	} )

} );
